import { TGlobalRecruitmentProfilePreviewState } from '../../../../libs/store';
import { TAction } from '../../../../../../../../shared/frontend/scripts/actions/types/action';
import _ from 'lodash';
import { serializeRecruitmentProfile } from '../../../../../../../../shared/frontend/scripts/recruitment/utils';

// Profiles are kept as an obj of { [profileId]: profileState },
// as there could be multiple profile
// previews on the same page. This allows us to track loading state
// independently of eachother and request many profiles at once.
const initialState = {
  profiles: {}
};

const FETCH_PROFILE = 'RECRUITMENT_PROFILE_PREVIEW/FETCH_PROFILE';
const LOAD_PROFILE_FAIL = 'RECRUITMENT_PROFILE_PREVIEW/LOAD_PROFILE_FAIL';
const LOAD_PROFILE_SUCCESS = 'RECRUITMENT_PROFILE_PREVIEW/LOAD_PROFILE_SUCCESS';

const fetchRecruitmentProfile = (profileId: string) => ({
  type: FETCH_PROFILE,
  payload: { profileId }
});

const loadRecProfileSuccess = (profile: any, profileId: string) => ({
  type: LOAD_PROFILE_SUCCESS,
  payload: { profile, profileId }
});

const loadRecProfileFailure = (profileId: string) => ({
  type: LOAD_PROFILE_FAIL,
  payload: { profileId }
});

function recruitmentProfilePreviewReducer(
  state: TGlobalRecruitmentProfilePreviewState = initialState,
  action: TAction<any>
) {
  switch (action.type) {
    case FETCH_PROFILE: {
      const { profileId } = action.payload;
      const { profiles } = state;
      const profile = state.profiles[profileId] || {};

      return {
        ...state,
        profiles: {
          ...profiles,
          [profileId]: {
            profileId,
            profile: profile.profile || {},
            loading: _.isEmpty(profile.profile)
          }
        }
      };
    }
    case LOAD_PROFILE_FAIL: {
      const { profileId } = action.payload;
      const { profiles } = state;
      const profile = profiles[profileId]?.profile;
      return {
        ...state,
        profiles: {
          ...profiles,
          [profileId]: {
            ...profile,
            loading: false,
            loaded: true,
            error: true,
            profile: {}
          }
        }
      };
    }
    case LOAD_PROFILE_SUCCESS: {
      const { profiles } = state;
      const { profile, profileId } = action.payload;
      const p = profiles[profileId]?.profile;

      return {
        ...state,
        profiles: {
          ...state.profiles,
          [profileId]: {
            ...p,
            loading: false,
            loaded: true,
            error: false,
            profile: serializeRecruitmentProfile({}, profile)
          }
        }
      };
    }
    default: {
      return state;
    }
  }
}

export const actionTypes = {
  FETCH_PROFILE,
  LOAD_PROFILE_FAIL,
  LOAD_PROFILE_SUCCESS
};

export const actions = {
  fetchRecruitmentProfile,
  loadRecProfileSuccess,
  loadRecProfileFailure
};

export default recruitmentProfilePreviewReducer;
